module.exports = __webpack_public_path__ + "static/media/Foremost.26a85cc2.webp";